import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MobilePageContainer } from 'components/Mobile/components/PageContainer/pageContainer.mobile';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';
import { Notifications } from 'components/Mobile/pages/notifications/components/MobileNotifications/notifications.mobile';

export const MobileNotifications = () => {
    useFullStoryPageView({ pageName: `${mobileAppConfig.notifications.title} (mobile)` });
    return (
        <MobilePageContainer>
            <Notifications />
        </MobilePageContainer>
    );
};
